<template>
  <div class="content-container" style="height: auto !important">
    <div class="content-box" style="margin-bottom: 20px">
      <search-comp @onSearch="attachData" @onReset="onReset">
        <div class="das-form-container">
          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col col-3">
                <div class="das-form-input">
                  <div class="label">Khách sạn</div>
                  <div class="child-w-80">
                    <el-select
                      v-model="searchParams.hotelIdList"
                      multiple
                      collapse-tags
                    >
                      <el-option
                        v-for="(hotel, index) in hotelList"
                        :key="index"
                        :value="hotel.id"
                        :label="hotel.name"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
              </div>

              <div class="das-form-col col-3">
                <div class="das-form-input">
                  <div class="label">Ngày</div>
                  <div class="child-w-80">
                    <!-- :date-data="agentItem.representative_card_date" -->
                    <!-- v-model="agentItem.representative_card_date" -->
                    <!-- @changeCalendar="onChangeDate2" -->
                    <calendar-select
                      v-model="searchParams.date"
                      style="display: block; width: 200px"
                      mode="date"
                      @input="changeDate"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </search-comp>
      <div class="section-box outline" style="max-height: 600px">
        <div class="das-form-container">
          <div class="das-form-title-container justify-space-between">
            <div class="das-form-title">
              <span class="main-title">Báo cáo quản lí chung</span>
            </div>
            <div class="button-containers-title">
              <InfoBtn @click="dialogFormVisible = true" />
              <el-dropdown trigger="click" @command="handleCommand">
                <button class="btn medium primary outline download-button">
                  <i class="el-icon-download"></i>
                </button>
                <el-dropdown-menu>
                  <el-dropdown-item command="pdf">Xuất PDF</el-dropdown-item>
                  <el-dropdown-item command="excel"
                    >Xuất Excel</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
              <!-- <button class="btn primary small">Xuất Excel</button> -->
            </div>
            <!-- <button class="btn medium primary outline">Thêm</button> -->
          </div>
          <hr />
          <div
            v-loading="loading"
            class="grid-scroll mt-10"
            style="height: 500px"
          >
            <GridVx
              ref="agGrid"
              :columns="columns"
              :rows="rows"
              class="agGrid"
              dom-layout="scroll"
              :default-col-def="defaultColDef"
              :auto-select-first-row="false"
              :auto-size-cell="true"
              row-selection="false"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="content-box">
      <search-comp @onSearch="attachDataForecast" @onReset="onResetForecast">
        <div class="das-form-container">
          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col col-3">
                <div class="das-form-input">
                  <div class="label">Khách sạn</div>
                  <div class="child-w-80">
                    <el-select
                      v-model="searchParamsForecast.hotelIdList"
                      multiple
                      collapse-tags
                    >
                      <el-option
                        v-for="(hotel, index) in hotelList"
                        :key="index"
                        :value="hotel.id"
                        :label="hotel.name"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
              </div>

              <div class="das-form-col col-3">
                <div class="das-form-input">
                  <div class="label">Ngày</div>
                  <div class="child-w-80">
                    <!-- :date-data="agentItem.representative_card_date" -->
                    <!-- v-model="agentItem.representative_card_date" -->
                    <!-- @changeCalendar="onChangeDate2" -->
                    <calendar-select
                      v-model="searchParamsForecast.date"
                      style="display: block; width: 200px"
                      mode="date"
                      :min-max="{
                        min: this.$moment().format('YYYY-MM-DD')
                      }"
                      @input="changeDateForecast"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </search-comp>
      <div class="section-box outline" style="max-height: 500px">
        <div class="das-form-container">
          <div class="das-form-title-container justify-space-between">
            <div class="das-form-title">
              <span class="main-title">Dự báo</span>
            </div>
            <div class="button-containers-title">
              <InfoBtn @click="dialogFormVisibleForecast = true" />
              <el-dropdown trigger="click" @command="handleCommandForecast">
                <button class="btn medium primary outline download-button">
                  <i class="el-icon-download"></i>
                </button>
                <el-dropdown-menu>
                  <el-dropdown-item command="pdf">Xuất PDF</el-dropdown-item>
                  <el-dropdown-item command="excel"
                    >Xuất Excel</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
              <!-- <button class="btn primary small">Xuất Excel</button> -->
            </div>
            <!-- <button class="btn medium primary outline">Thêm</button> -->
          </div>
          <hr />
          <div
            v-loading="loading"
            class="grid-scroll mt-10"
            style="height: 400px"
          >
            <GridVx
              ref="agGrid"
              :columns="columnsForcast"
              :rows="rowsForecast"
              dom-layout="scroll"
              :header-height-setter="headerHeightSetter"
              :is-header-height-setter="true"
              :default-col-def="defaultColDef"
              class="agGrid"
              :auto-select-first-row="false"
              :auto-size-cell="true"
              row-selection="false"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- <div ref="echartBarchart" class="echart-barchart"></div> -->
    <!-- <bar-chart :options="optionChart"> </bar-chart> -->
    <!-- <vchart
      style="height: 400px"
      class="chart"
      :option="optionChart"
      autoresize
    /> -->

    <el-dialog
      title="Chú thích"
      :visible.sync="dialogFormVisibleForecast"
      :close-on-click-modal="false"
      width="500px"
    >
      <div class="das-form-container">
        <div class="das-form-group">
          <ul class="annotate-container">
            <li>Ngày: hiển thị ngày</li>
            <li>Thứ: Hiển thị Thứ theo ngày</li>
            <li>Số lượng phòng đến: Số lượng phòng có khách dự kiến đến</li>
            <li>Số lượng phòng đi: Số lượng phòng có khách dự kiến đi</li>
            <li>
              Số lượng phòng bị chiếm: Số lượng phòng đa được gán, theo Kế hoạch
              đặt phòng
            </li>
            <li>
              Công suất: bằng phòng bị chiếm/ tổng số phòng vật lý của khách sạn
            </li>
            <li>
              Người lớn & trẻ em: Tổng số lượng người lớn và trẻ em trong đặt
              phòng của ngày được liệt kê
            </li>
            <li>Giá phòng trung bình: bằng Doanh thu phòng/ phòng bị chiếm</li>
            <li>
              Doanh thu phòng: bằng tổng Các giao dịch được thêm vào ngày với
              nhóm giao dịch Doanh Thu, Loại Thuê phòng trong các đặt phòng
              (bằng giá phòng* số phòng + tiền dịch vụ đi cùng phòng ( minibar,
              Laundry..))
            </li>
            <li>
              Doanh thu tổng: bằng tổng Giao dịch được thêm vào ngày với Nhóm
              giao dịch = Doanh thu trong các đặt phòng (bằng tổng doanh thu
              phòng + dịch vụ + Các doanh thu từ hạng mục khác bao gồm: Nhà
              hàng, bán hàng (không bao gồm vé))
            </li>
            <li>Tổng cộng: Tổng dữ liệu của tất cả các ngày theo từng cột</li>
          </ul>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small"
            @click="dialogFormVisibleForecast = false"
          >
            {{ $t('button.cancel') }}
          </button>
        </div>
      </span>
    </el-dialog>
    <el-dialog
      title="Chú thích"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <div class="das-form-container">
        <div class="das-form-group">
          <ul class="annotate-container">
            <li>Ngày: Hiển thị dữ liệu theo ngày được tìm kiếm</li>
            <li>
              Lũy kế tháng: Hiển thị tổng số dữ liệu của từng chi tiết của tất
              cả các ngày trong tháng đã có dữ liệu theo tháng được tìm kiếm
            </li>
            <li>
              Lũy kế năm: hiển thị tổng số dữ liệu của từng chi tiết của tất cả
              các ngày trong năm đã có dữ liệu theo năm được tìm kiếm Của cột
              chi tiết
            </li>
          </ul>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button class="btn primary small" @click="dialogFormVisible = false">
            {{ $t('button.cancel') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import { getSourceApi } from '@/api/Statistics/source'
import SelectWithSearchTable from '@/components/inputs/SelectWithSearchTable.vue'
import { getAllHotel } from '@/api/hotel'
import {
  getGeneralListReport,
  getGeneralListReportExcel,
  getForecastListReport,
  getForecastListReportExcel
} from '@/api/report_service/generalManagement.js'
import CalendarSelect from '@/components/CalendarSelect/CalendarSelect.vue'
import InfoBtn from './components/InfoBtn.vue'
import treeViewVue from '@/components/selectWithTreeView/treeView.vue'
import { downFile } from '@/utils/file-handler'

export default {
  components: {
    CalendarSelect,
    SelectWithSearchTable,
    InfoBtn
    // VChart
  },
  // provide: {
  //   [THEME_KEY]: 'dark'
  // },
  data() {
    return {
      defaultColDef: {
        flex: 1,
        // resizable: true,
        // sortable: true,
        suppressMovable: true,
        autoHeight: true,
        wrapText: true,
        headerComponentParams: {
          template:
            '<div class="ag-cell-label-container" role="presentation">' +
            '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
            '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
            // '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>' +
            // '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon"></span>' +
            // '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon"></span>' +
            // '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon"></span>' +
            '    <span ref="eText" class="ag-header-cell-text" role="columnheader" style="white-space: normal;"></span>' +
            // '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
            '  </div>' +
            '</div>'
        }
      },
      dialogFormVisibleForecast: false,
      dialogFormVisible: false,
      hotelList: [],
      loading: false,
      searchParams: {
        date: this.$moment().format('YYYY-MM-DD'),
        hotelIdList: []
      },
      searchParamsForecast: {
        date: this.$moment().add(30, 'd').format('YYYY-MM-DD'),
        hotelIdList: []
      },
      defaultSearchParams: {
        date: this.$moment().format('YYYY-MM-DD'),
        hotelId: []
      },

      sourceOptions: [],
      columnsSource: [
        {
          headerName: 'Mã nguồn',
          field: 'code',
          width: 100
        },
        {
          headerName: 'Mô tả',
          field: 'desc'
        }
      ],
      columnsForcast: [
        {
          headerName: this.$t('grid.column.date'),
          field: 'date',
          minWidth: 120,
          maxWidth: 120,
          // cellClass: "grid-cell-centered",
          sortable: false
        },
        {
          headerName: this.$t('grid.column.dayofWeek'),
          field: 'weekday',
          minWidth: 100,
          // cellClass: "grid-cell-centered",
          sortable: false
        },
        {
          headerName: this.$t('grid.column.numRoomArrive'),
          field: 'countArriveDate',
          // cellClass: "grid-cell-centered",
          sortable: false,
          minWidth: 100
        },

        {
          headerName: this.$t('grid.column.numRoomDepart'),
          field: 'countDepartDate',
          // cellClass: "grid-cell-centered",
          sortable: false,
          minWidth: 100
        },
        {
          headerName: this.$t('grid.column.occupiedRoom'),
          field: 'countOccupiedRoom',
          // cellClass: "grid-cell-centered",
          sortable: false,
          minWidth: 100
        },
        {
          headerName: this.$t('grid.column.capacity'),
          field: 'ratioOccupiedRoom',
          valueGetter: params => {
            if (params?.data?.ratioOccupiedRoom) {
              return params?.data?.ratioOccupiedRoom.toFixed(2)
            }
          },
          // cellClass: "grid-cell-centered",
          sortable: false,
          minWidth: 100
        },
        {
          headerName: this.$t('grid.column.adultAndChild'),
          field: 'numOfGuest',
          // cellClass: "grid-cell-centered",
          sortable: false,
          minWidth: 100
        },
        {
          headerName: this.$t('grid.column.averagePriceRoom'),
          field: 'averageRoomPrice',
          valueGetter: params => {
            return this.$displayCurrency(params.data.averageRoomPrice)
          },
          tooltipValueGetter: params => {
            return this.$displayCurrency(params.data.averageRoomPrice)
          },
          // cellClass: "grid-cell-centered",
          sortable: false,
          minWidth: 100
        },
        {
          headerName: this.$t('grid.column.roomRevenue'),
          field: 'roomRevenue',
          valueGetter: params => {
            return this.$displayCurrency(params.data.roomRevenue)
          },
          tooltipValueGetter: params => {
            return this.$displayCurrency(params.data.roomRevenue)
          },
          // cellClass: "grid-cell-centered",
          sortable: false,
          minWidth: 100
        },
        {
          headerName: this.$t('grid.column.allRevenue'),
          field: 'totalRevenue',
          valueGetter: params => {
            return this.$displayCurrency(params.data.totalRevenue)
          },
          tooltipValueGetter: params => {
            return this.$displayCurrency(params.data.totalRevenue)
          },
          // cellClass: "grid-cell-centered",
          sortable: false,
          minWidth: 100
        }
      ],

      columns: [
        {
          headerName: this.$t('grid.column.detail'),
          field: 'name',
          tooltipField: 'name',
          flex: 1,
          // cellClass: "grid-cell-centered",
          sortable: false
        },
        {
          headerName: this.$t('grid.column.currentYear'),
          // field: 'this_day',
          cellClass: 'grid-cell-centered',
          headerClass: [
            'header-cell-suffix-group',
            'header-group-cell-divide',
            'header-group-cell-divide-right',
            'header-cell-center'
          ],
          // maxWidth: 200,
          marryChildren: true,
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          children: [
            {
              headerName: this.$t('grid.column.date'),
              sortable: false,
              field: 'this_day',
              tooltipField: 'this_day',
              valueGetter: params => {
                return this.$displayCurrency(params.data.this_day)
              },
              tooltipValueGetter: params => {
                return this.$displayCurrency(params.data.this_day)
              },

              minWidth: 100,
              maxWidth: 150
            },
            {
              headerName: this.$t('grid.column.monthAccumulated'),
              sortable: false,
              field: 'this_month',
              valueGetter: params => {
                return this.$displayCurrency(params.data.this_month)
              },
              tooltipValueGetter: params => {
                return this.$displayCurrency(params.data.this_month)
              },
              minWidth: 100,
              maxWidth: 150
            },
            {
              headerName: this.$t('grid.column.yearAccumulated'),
              sortable: false,
              field: 'this_year',
              valueGetter: params => {
                return this.$displayCurrency(params.data.this_year)
              },
              tooltipValueGetter: params => {
                return this.$displayCurrency(params.data.this_year)
              },
              minWidth: 100,
              maxWidth: 150
            }
          ]
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.lastYear'),
          // field: 'name',
          cellClass: 'grid-cell-centered',
          headerClass: [
            'header-cell-suffix-group',
            'header-group-cell-divide',
            'header-group-cell-divide-right',
            'header-cell-center'
          ],
          // maxWidth: 200,
          marryChildren: true,
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          children: [
            {
              headerName: this.$t('grid.column.date'),
              field: 'last_day',
              valueGetter: params => {
                return this.$displayCurrency(params.data.last_day)
              },
              tooltipValueGetter: params => {
                return this.$displayCurrency(params.data.last_day)
              },
              minWidth: 100,
              maxWidth: 150
            },
            {
              headerName: this.$t('grid.column.monthAccumulated'),
              field: 'last_month',
              valueGetter: params => {
                return this.$displayCurrency(params.data.last_month)
              },
              tooltipValueGetter: params => {
                return this.$displayCurrency(params.data.last_month)
              },
              minWidth: 100,
              maxWidth: 150
            },
            {
              headerName: this.$t('grid.column.yearAccumulated'),
              field: 'last_year',
              valueGetter: params => {
                return this.$displayCurrency(params.data.last_year)
              },
              tooltipValueGetter: params => {
                return this.$displayCurrency(params.data.last_year)
              },
              minWidth: 100,
              maxWidth: 150
            }
          ]
          // cellClass: "grid-cell-centered",
        }
      ],
      rows: [],
      rowsForecast: []
    }
  },
  created() {
    this.getListSource()
    this.getListHotel()
  },
  mounted() {
    this.attachData()
    this.attachDataForecast()
    // this.importChart()
  },
  methods: {
    handleCommand(cmmd) {
      // this.$message('click on item ' + cmmd)
      switch (cmmd) {
        case 'pdf':
          break
        case 'excel':
          this.downloadExcel()
          break
        default:
          this.$message('click on item ' + cmmd)
          break
      }
    },
    handleCommandForecast(cmmd) {
      // this.$message('click on item ' + cmmd)
      switch (cmmd) {
        case 'pdf':
          break
        case 'excel':
          this.downloadExcelForecast()
          break
        default:
          this.$message('click on item ' + cmmd)
          break
      }
    },
    headerHeightGetter() {
      var columnHeaderTexts = [
        ...document.querySelectorAll('.ag-header-cell-text')
      ]
      var clientHeights = columnHeaderTexts.map(
        headerText => headerText.clientHeight
      )
      var tallestHeaderTextHeight = Math.max(...clientHeights)

      return tallestHeaderTextHeight
    },
    headerHeightSetter() {
      var padding = 30
      var height = this.headerHeightGetter() / 2 + padding
      this.$refs.agGrid.gridApi.setHeaderHeight(height)
      this.$refs.agGrid.gridApi.resetRowHeights()
    },
    async getListSource() {
      const data = await getSourceApi({ isActive: 1 })
      this.sourceOptions = data.data
    },
    onSelectRowSource(val) {
      this.searchParams.sourceId = val.id
    },
    async getListHotel() {
      const data = await getAllHotel()
      this.hotelList = data.data
    },
    async attachData() {
      try {
        this.loading = true

        const data = await getGeneralListReport(this.searchParams)
        this.rows = data.data
      } catch (error) {
      } finally {
        this.loading = false
      }
    },
    async downloadExcel() {
      try {
        this.loading = true
        const data = await getGeneralListReportExcel(this.searchParams)
        const date = this.$moment().format('DD-MM-YYYY')
        downFile(data, 'bao_cao_quan_ly_chung_' + date + '.xlsx')
      } catch (error) {
      } finally {
        this.loading = false
      }
    },
    async attachDataForecast() {
      try {
        this.loading = true

        const data = await getForecastListReport(this.searchParamsForecast)
        this.rowsForecast = data.data
      } catch (error) {
      } finally {
        this.loading = false
      }
    },
    async downloadExcelForecast() {
      try {
        this.loading = true

        const data = await getForecastListReportExcel(this.searchParamsForecast)
        const date = this.$moment().format('DD-MM-YYYY')
        downFile(data, 'bao_cao_quan_ly_chung_du_doan_' + date + '.xlsx')
      } catch (error) {
      } finally {
        this.loading = false
      }
    },
    onReset() {
      this.searchParams = { ...this.defaultSearchParams }
      this.attachData()
    },
    onResetForecast() {
      this.searchParamsForecast = { ...this.defaultSearchParams }
      this.attachDataForecast()
    },
    changeDate(val) {
      // console.log(val)
      this.searchParams.date = val
    },
    changeDateForecast(val) {
      // console.log(val)
      this.searchParamsForecast.date = val
    }
  }
}
</script>

<style lang="scss">
.button-containers-title {
  display: flex;
  /* margin-top: 20px; */
  justify-content: flex-end;
  align-items: flex-end;
  gap: 10px;
  .download-button {
    padding: 10px 10px;
  }
}
</style>
